import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { installChunkRecovery } from "./lib/chunk-recovery";

// Auto-recovery for stale-chunk errors after deploys. Listens for
// vite:preloadError + unhandledrejection + resource-load errors that
// indicate the user's tab is pointing at code that no longer exists.
// See src/lib/chunk-recovery.ts.
installChunkRecovery();

// Initialize Sentry for error tracking
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance monitoring sample rate (adjust as needed)
  tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,
  // Session replay sample rate
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
